<template>
  <a-modal
    class="attach-sample-modal download"
    :title="$t('Sample4')"
    :visible="visible"
    :maskClosable="false"
    centered
    @cancel="handleCancel"
  >
    <!-- custom footer -->
    <template v-slot:footer>
      <a-button key="back" @click="handleCancel">{{$t("Common_Cancel")}}</a-button>
      <a-button
        key="submit"
        type="primary"
        :loading="loading"
        @click="handleOk"
      >
        {{$t("Common_Download")}}
      </a-button>
    </template>

    <!-- contents -->
    <div class="content-text">
      <div>{{$t("Sample5")}}</div>
    </div>
    <div class="content-group">
      <ul>
        <li>
          <span class="title">No</span>
          <span class="value">{{ attachSampleInfo.attachSampleNo }}</span>
        </li>
        <li>
          <span class="title">{{$t("Common_Content")}}</span>
          <span class="value">{{ attachSampleInfo.attachSampleContent }}</span>
        </li>
        <li>
          <span class="title">{{$t("Common_RegDate")}}</span>
          <span class="value">{{
            timeFormatFromUTCEpoch(attachSampleInfo.regEpoch)
          }}</span>
        </li>
      </ul>
    </div>
  </a-modal>
</template>

<script>
import { toRefs, ref, reactive, computed } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import { apiUrl, timeFormatFromUTCEpoch } from "@/utils/common";
import fileDownload from "js-file-download";

export default {
  name: "SampleDownloadModal",
  props: {
    visible: Boolean,
    toggleModal: Function,
  },
  setup(props) {
    const store = useStore();
    const attachSampleState = computed(() => store.getters["attachSample/STATE"]);
    const attachSampleInfo = computed(
      () =>
        attachSampleState.value.data.list.filter(
          (item) => item.attachSampleNo === attachSampleState.value.selectedNo
        )[0]
    );

    const state = reactive({
      loading: false,
    });

    const handleOk = async () => {
      state.loading = true;

      const params = {
        attachSampleNo: attachSampleInfo.value.attachSampleNo,
      };

      try {
        const response = await axios({
          method: "post",
          headers: {
            "Content-Type": "application/octet-stream",
          },
          responseType: "arraybuffer",
          url: apiUrl + "AttachSample/Download",
          data: params,
        });
        if (response && !response.data.error) {
          store.dispatch("attachSample/DOWNLOAD_ATTACH_SAMPLE", response);
          fileDownload(
            response.data,
            "mudfix_attach_sample" + attachSampleInfo.value.attachSampleExt
          );
        }
      } catch (error) {
        console.log("attach sample download error", error);
      }
      state.loading = false;

      props.toggleModal();
    };

    const handleCancel = () => {
      props.toggleModal();
    };

    return {
      ...toRefs(state),
      handleOk,
      handleCancel,
      attachSampleInfo,
      timeFormatFromUTCEpoch,
    };
  },
};
</script>